import styled from "styled-components";

const HorizontalLine = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  border-radius: 10em;
  border-top: 1px solid #fff5ee;
  opacity: 0.75;
`;

export default HorizontalLine;
